import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'uniqueBy',
})
export class UniqueByPipe implements PipeTransform {
  transform<T>(value :T[], prop :string) :T[] {
    if (!Array.isArray(value) || !prop) {
      return value;
    }

    const seen = new Set();

    return value.filter((item :T) => !seen.has(item[prop]) && seen.add(item[prop]));
  }
}
